import React from 'react';

export const GalleryCardSkeletonList = () => (
  <div className="gallery-card-grid" data-testid="gallery-skeleton" aria-label="Inhalt wird geladen">
    {[1, 2, 3].map((i) => (
      <div key={i}>
        <article className="gallery-card gallery-card--skeleton" data-testid="gallery-skeleton-card">
          <div className="skeleton-pulse skeleton-image" />
          <div className="gallery-card-body">
            <div className="skeleton-pulse skeleton-date" />
            <div className="skeleton-pulse skeleton-title" />
            <div className="skeleton-pulse skeleton-text" />
            <div className="skeleton-pulse skeleton-text skeleton-text--short" />
            <div className="gallery-card-footer">
              <div className="skeleton-pulse skeleton-footer" />
            </div>
          </div>
        </article>
      </div>
    ))}
  </div>
);

export const GalleryPhotoGridSkeleton = () => (
  <div className="album-grid" data-testid="gallery-album-skeleton" aria-label="Inhalt wird geladen">
    {Array.from({ length: 8 }, (_, i) => (
      <figure className="album-photo album-photo--skeleton" key={i}>
        <div className="skeleton-pulse skeleton-photo-image" />
      </figure>
    ))}
  </div>
);
